/** Shared authentication failures returned by the API and interpreted by login and refresh clients. */
export enum AuthenticationErrorCode {
    UserNotActive = 1001,
    UserDeleted = 1002,
    UserInactiveStatus = 1003,
    UserCannotLoginViaWeb = 1004,
    UserCannotLoginViaMobile = 1005,
    UserCannotLoginViaManager = 1006,
    UserCannotLoginViaClient = 1007,
    UserCannotLoginViaSubcontractor = 1008,
    TokenWasUsed = 1009,
    ConcurrentSessionLimitReached = 1010,
    MfaVerificationRequired = 1011,
    /** Refresh clients must stop retrying and sign in again when the stored session is no longer valid. */
    SessionInvalidated = 1012,
    /** The tenant is in maintenance mode, so only System Administrators may sign in or keep calling the API. */
    LoginsDisabled = 1013,
}
